import { Popover } from '@base-ui/react/popover'
import { twMerge } from 'tailwind-merge'
import type { PartProps } from '../../../lib/part-props'

interface PopoverDescriptionProps extends PartProps<Popover.Description.Props> {
  className?: string
}

function PopoverDescription({ className, children, ...props }: PopoverDescriptionProps) {
  return (
    <Popover.Description
      className={twMerge('font-350 text-foreground-secondary text-sm leading-normal', className)}
      {...props}
    >
      {children}
    </Popover.Description>
  )
}

export { PopoverDescription }
